var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-form',{attrs:{"data":_vm.data},on:{"change":_vm.handleFilterChange}}),_c('status-table',{attrs:{"data":_vm.ruleData || _vm.data}}),_c('monitor',{staticClass:"mt-4",attrs:{"data":_vm.ruleData || _vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }